export const STATUS = '@revolutility/REQUEST_PAYMENT_STATUS'
export const UPDATE = '@revolutility/UPDATE_PAYMENT_STATUS'
export const CLEAR = '@revolutility/PAYMENT_CLEAR'
export default ({
  status: params => ({ type: STATUS, params }),
  update: result => ({ type: UPDATE, result }),
  clear: () => ({ type: CLEAR })
})
